import React from "react";
import styled, { css } from "styled-components";
import isEmpty from "lodash/isEmpty";
const Errors = styled.div(
  ({ theme }) => css`
    width: 100%;
    margin-top: 3px;
    color: ${theme.colors.variant.danger};

    > * {
      margin-right: 5px;

      &:last-child {
        margin-right: 0;
      }
    }
  `
);
const FormErrors = ({ errors }) => {
  if (isEmpty(errors) || Object.values(errors).every((v) => !v)) return null;
  return /* @__PURE__ */ React.createElement(Errors, null, Object.entries(errors).map(([fieldKey, value]) => /* @__PURE__ */ React.createElement("span", { key: fieldKey }, String(value), ".")));
};
export default FormErrors;
